<!-- src/App.vue -->
<template>
  <div id="app">
    <!-- PC端导航栏 -->
    <div class="pc-navbar" v-if="isPc">
      <div class="nav-container">
        <div class="brand" @click="goHome">
          🎨 优毕学社
        </div>
        <ul class="nav-menu">
          <!-- 普通导航项 -->
          <li class="nav-item" v-for="item in navItems" :key="item.path" @click="!item.children && navigateTo(item.path)">
            <div class="nav-link-wrapper" :class="{ active: isActive(item.path) }">
              <span>{{ item.name }}</span>
              <span v-if="item.children" class="dropdown-arrow">▼</span>
              <!-- 二级下拉菜单 -->
              <ul v-if="item.children" class="dropdown-menu">
                <li v-for="child in item.children" :key="child.path" @click.stop="navigateTo(child.path)">
                  <span class="dropdown-item">{{ child.name }}</span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 移动端导航栏 -->
    <div class="mobile-navbar" v-else>
      <div class="mobile-nav-container">
        <div class="brand" @click="goHome">
          🎨 作品分类
        </div>
        <button class="menu-toggle" @click="toggleMobileMenu">
          <svg viewBox="0 0 24 24">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
      </div>

      <!-- 移动端滑出菜单 -->
      <div class="mobile-menu" :class="{ open: mobileMenuOpen }">
        <div class="mobile-nav-item" v-for="item in navItems" :key="item.path">
          <!-- 无子菜单项 -->
          <router-link v-if="!item.children" :to="item.path" class="mobile-nav-link" @click.native="closeMobileMenu">
            {{ item.name }}
          </router-link>
          <!-- 有子菜单项 - 折叠面板 -->
          <div v-else class="collapse-item">
            <div class="collapse-header" @click="toggleCollapse(item.path)" :class="{ active: isWorksActive }">
              <span>{{ item.name }}</span>
              <span class="collapse-arrow" :class="{ open: collapsedItems[item.path] }">▼</span>
            </div>
            <div class="collapse-content" :class="{ open: collapsedItems[item.path] }">
              <router-link v-for="child in item.children" :key="child.path" :to="child.path" class="sub-nav-link" @click.native="closeMobileMenu">
                {{ child.name }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-overlay" :class="{ show: mobileMenuOpen }" @click="closeMobileMenu"></div>
    </div>

    <!-- 主内容区域 -->
    <div class="page-container" :style="{ paddingTop: isPc ? '80px' : '0' }">
      <router-view />
    </div>

    <!-- 底部信息 -->
    <div class="app-footer" :style="{ marginTop: isPc ? '0' : '2rem' }">
      <p>© 2025 优毕学社 | 支持二级分类 | PC端下拉菜单 / 移动端折叠面板</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isPc: true,
      mobileMenuOpen: false,
      collapsedItems: {
        '/works': false
      },
      navItems: [
        { name: '🏠 首页', path: '/' },
        // { name: '📖 关于我们', path: '/about' },
        { name: '⚙️ 资源获取', path: '/services' },
        { 
          name: '🎨 作品分类', 
          path: '/works',
          children: [
			  { name: '💻 计算机', path: '/works/data-viz' },
            { name: '🌅 汉语言文学', path: '/works/ui-design' },
            { name: '📊 经济管理', path: '/works/web-dev' },
            // { name: '📱 移动应用', path: '/works/mobile-app' },
            // { name: '🎯 品牌设计', path: '/works/branding' }
            
          ]
        },
        { name: '📞 联系方式', path: '/contact' }
      ]
    };
  },
  computed: {
    isWorksActive() {
      return this.$route.path.startsWith('/works');
    }
  },
  mounted() {
    this.checkPlatform();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    checkPlatform() {
      this.isPc = window.innerWidth >= 768;
    },
    handleResize() {
      this.isPc = window.innerWidth >= 768;
      if (this.isPc) {
        this.closeMobileMenu();
      }
    },
    goHome() {
      this.navigateTo('/');
    },
    navigateTo(path) {
      if (this.$route.path === path) return;
      this.$router.push(path);
    },
    isActive(path) {
      if (path === '/works') {
        return this.$route.path.startsWith('/works');
      }
      return this.$route.path === path;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.style.overflow = '';
    },
    toggleCollapse(path) {
      this.collapsedItems[path] = !this.collapsedItems[path];
    }
  },
  watch: {
    '$route'() {
      this.closeMobileMenu();
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: system-ui, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
  background: #f8fafc;
  color: #0f172a;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* PC端导航栏 */
.pc-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.nav-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}

.brand {
  cursor: pointer;
  font-weight: 700;
  font-size: 1.35rem;
  background: linear-gradient(135deg, #0f2b3d, #1e4a76);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}

.nav-menu {
  display: flex;
  gap: 2rem;
  list-style: none;
}

.nav-item {
  position: relative;
  list-style: none;
}

.nav-link-wrapper {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  padding: 0.5rem 0;
  font-weight: 500;
  font-size: 1rem;
  color: #334155;
  transition: all 0.2s;
}

.nav-link-wrapper.active {
  color: #2563eb;
  font-weight: 600;
}

.dropdown-arrow {
  font-size: 0.7rem;
  color: #64748b;
}

.nav-link-wrapper:hover {
  color: #0f172a;
}

/* 下拉菜单 */
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 200px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  margin-top: 0.5rem;
  z-index: 100;
  border: 1px solid #e2e8f0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  list-style: none;
}

.nav-item:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}

.dropdown-item {
  display: block;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.9rem;
  color: #334155;
}

.dropdown-item:hover {
  background: #f1f5f9;
  color: #2563eb;
}

/* 移动端导航栏 */
.mobile-navbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #e2e8f0;
}

.mobile-nav-container {
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}

.menu-toggle {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

.menu-toggle svg {
  width: 26px;
  height: 26px;
  stroke: #334155;
  stroke-width: 2;
  fill: none;
}

.mobile-menu {
  position: fixed;
  top: 60px;
  left: -100%;
  width: 80%;
  max-width: 300px;
  height: calc(100% - 60px);
  background: white;
  transition: left 0.3s ease;
  z-index: 1001;
  overflow-y: auto;
  box-shadow: 2px 0 20px rgba(0, 0, 0, 0.1);
}

.mobile-menu.open {
  left: 0;
}

.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: none;
}

.mobile-overlay.show {
  display: block;
}

.mobile-nav-item {
  border-bottom: 1px solid #eef2f6;
}

.mobile-nav-link {
  display: block;
  padding: 1rem 1.5rem;
  text-decoration: none;
  font-size: 1rem;
  color: #334155;
}

.mobile-nav-link.active {
  color: #2563eb;
  font-weight: 600;
  background: #eef2ff;
}

.collapse-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  cursor: pointer;
  background: white;
}

.collapse-header.active {
  color: #2563eb;
  font-weight: 600;
  background: #eef2ff;
}

.collapse-arrow {
  transition: transform 0.3s;
  font-size: 0.7rem;
  color: #64748b;
}

.collapse-arrow.open {
  transform: rotate(180deg);
}

.collapse-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: #f8fafc;
}

.collapse-content.open {
  max-height: 300px;
}

.sub-nav-link {
  display: block;
  padding: 0.75rem 1.5rem 0.75rem 3rem;
  text-decoration: none;
  font-size: 0.9rem;
  color: #475569;
  border-bottom: 1px solid #eef2f6;
}

.sub-nav-link.active {
  color: #2563eb;
  background: #eef2ff;
}

/* 页面容器 */
.page-container {
  flex: 1;
}

.app-footer {
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  text-align: center;
  padding: 1.5rem;
  color: #5b6e8c;
  font-size: 0.8rem;
}

@media (min-width: 769px) {
  .app-footer {
    margin-top: 0;
  }
}
</style>